import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const GlobeSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.99175 0.666504C4.39175 0.666504 0.666748 4.39984 0.666748 8.99984C0.666748 13.5998 4.39175 17.3332 8.99175 17.3332C13.6001 17.3332 17.3334 13.5998 17.3334 8.99984C17.3334 4.39984 13.6001 0.666504 8.99175 0.666504ZM14.7667 5.6665H12.3084C12.0472 4.63451 11.661 3.63826 11.1584 2.69984C12.6785 3.22317 13.9594 4.27627 14.7667 5.6665ZM9.00008 2.3665C9.69175 3.3665 10.2334 4.47484 10.5917 5.6665H7.40841C7.76675 4.47484 8.30841 3.3665 9.00008 2.3665ZM2.55008 10.6665C2.41675 10.1332 2.33341 9.57484 2.33341 8.99984C2.33341 8.42484 2.41675 7.8665 2.55008 7.33317H5.36675C5.30008 7.88317 5.25008 8.43317 5.25008 8.99984C5.25008 9.5665 5.30008 10.1165 5.36675 10.6665H2.55008ZM3.23341 12.3332H5.69175C5.95841 13.3748 6.34175 14.3748 6.84175 15.2998C5.32054 14.7785 4.03903 13.7249 3.23341 12.3332ZM5.69175 5.6665H3.23341C4.03903 4.2748 5.32054 3.22118 6.84175 2.69984C6.33915 3.63826 5.95296 4.63451 5.69175 5.6665ZM9.00008 15.6332C8.30841 14.6332 7.76675 13.5248 7.40841 12.3332H10.5917C10.2334 13.5248 9.69175 14.6332 9.00008 15.6332ZM10.9501 10.6665H7.05008C6.97508 10.1165 6.91675 9.5665 6.91675 8.99984C6.91675 8.43317 6.97508 7.87484 7.05008 7.33317H10.9501C11.0251 7.87484 11.0834 8.43317 11.0834 8.99984C11.0834 9.5665 11.0251 10.1165 10.9501 10.6665ZM11.1584 15.2998C11.6584 14.3748 12.0417 13.3748 12.3084 12.3332H14.7667C13.9594 13.7234 12.6785 14.7765 11.1584 15.2998ZM12.6334 10.6665C12.7001 10.1165 12.7501 9.5665 12.7501 8.99984C12.7501 8.43317 12.7001 7.88317 12.6334 7.33317H15.4501C15.5834 7.8665 15.6667 8.42484 15.6667 8.99984C15.6667 9.57484 15.5834 10.1332 15.4501 10.6665H12.6334Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default GlobeSvg;
